/* eslint-disable */
export default {
  dial: 'Discar',
  message: 'Mensagem',
  transfer: 'Transferir',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
